import { TemplateNavigationPath, Version } from "../models/templates";

export const transformPathToUrl = ({ path, version }: { path: TemplateNavigationPath; version: Version }): string => {
  let url = "/templates";
  for (const key of Object.keys(path)) {
    url += `/${path[key]}`;
  }

  // If all levels are present, append the version
  if (url.split("/").length - 1 == 4) {
    url += "/" + version;
  }

  return url;
};
